import { authenticationScreen } from "@groundspark/browser-auth";
import { installThemeColour } from "@groundspark/styles/colours";
import "maplibre-gl/dist/maplibre-gl.css";
import "@groundspark/styles/intelligence";
import { IntelligenceApplication } from "./app";
import { AuthenticationRequiredError, AuthManager } from "./auth";
import { brandLockupContent } from "./brand";
import { readConfig } from "./config";

const root = applicationRoot();

installThemeColour(document);

const authentication = new AuthManager(readConfig());
let application: IntelligenceApplication | null = null;

void start();

window.addEventListener("pagehide", () => application?.destroy(), { once: true });

async function start(): Promise<void> {
  showStartup("Verifying your Groundspark account…");
  try {
    if (!(await authentication.initialize())) {
      showSignIn();
      return;
    }
    application = new IntelligenceApplication(root, authentication, (error) => {
      application = null;
      showSignIn(error.message);
    });
    await application.start();
  } catch (error) {
    if (error instanceof AuthenticationRequiredError) {
      showSignIn(error.message);
      return;
    }
    showFatal(error);
  }
}

function showStartup(message: string): void {
  root.innerHTML = `
    <main class="auth-screen" id="main-content" tabindex="-1">
      <section class="auth-card">
        <div class="brand-lockup">${brandLockupContent()}</div>
        <p class="eyebrow">Secure campaign analysis</p>
        <div class="control-row"><span class="spinner" aria-hidden="true"></span><span data-message></span></div>
      </section>
    </main>`;
  const target = root.querySelector<HTMLElement>("[data-message]");
  if (target !== null) target.textContent = message;
}

function showSignIn(error?: string): void {
  root.replaceChildren(
    authenticationScreen(authentication, start, {
      appName: "Intelligence",
      subtitle: "Find electorally favourable areas",
      error,
    }),
  );
}

function showFatal(error: unknown): void {
  const message = error instanceof Error ? error.message : String(error);
  root.innerHTML = `
    <main class="auth-screen" id="main-content" tabindex="-1">
      <section class="auth-card">
        <div class="brand-lockup">${brandLockupContent()}</div>
        <p class="eyebrow">Campaign intelligence</p>
        <h1>Startup error</h1>
        <p class="auth-card__subtitle" data-error></p>
        <button class="button button--white" type="button" data-retry>Try again</button>
      </section>
    </main>`;
  const target = root.querySelector<HTMLElement>("[data-error]");
  if (target !== null) target.textContent = message;
  root.querySelector("[data-retry]")?.addEventListener("click", () => window.location.reload());
}

function applicationRoot(): HTMLElement {
  const value = document.querySelector<HTMLElement>("#app");
  if (value === null) throw new Error("The intelligence application root is missing.");
  return value;
}
